import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { InstrukcijaPlacanja } from './instrukcija-placanja';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-instrukcija-placanja-modal-update',
  templateUrl: './instrukcija-placanja-modal-update.component.html'
})
export class InstrukcijaPlacanjaModalUpdateComponent extends BaseModalUpdateComponent<InstrukcijaPlacanja> implements OnInit {

  constructor(
      protected modalContainerService: ModalContainerService<InstrukcijaPlacanja>,
      protected activeModal: NgbActiveModal,
      protected modalService: ModalService
  
    ) { 
      super(modalContainerService, activeModal,modalService);
    }

  

}
